export default {
  // 计算序号
  getNewIndex(index, page, size) {
    return index + 1 + (page - 1) * size
  }
}
